module.exports = __webpack_public_path__ + "images/category_lp/common/woman_50_2_4c860cbdf6f20dbe644ff9f36c037db3.png";